import { useState, useEffect, useCallback } from "react";

/**
 * Hook to track online/offline status and manage sync queue
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingSyncCount, setPendingSyncCount] = useState(0);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      // Trigger sync when coming back online
      syncPendingData();
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const syncPendingData = useCallback(async () => {
    // This would trigger sync of:
    // 1. Pending audio uploads
    // 2. Pending note generation requests
    // 3. Pending audit events
    // 4. Any queued Firestore writes
    console.log("Syncing pending data...");
    // Firestore handles its own offline queue automatically
    // We just need to handle audio uploads and AI processing
  }, []);

  return { isOnline, pendingSyncCount, syncPendingData };
}
